import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import axios from 'axios';
import { useNavigate, useLocation, Navigate } from 'react-router-dom'; // Dodano Navigate

import UserPersonalInfo from './UserPersonalInfo';
import UserFavorites from './UserFavorites';
import UserOrders from './UserOrders';
import UserAddresses from './UserAddresses';
import UserCart from './UserCart';
import '../styles/PageProfile.css';

function PageProfile() {
    const { logout } = useContext(AuthContext);
    const [userDetails, setUserDetails] = useState({});
    const [activeTab, setActiveTab] = useState('userInfo');
    const navigate = useNavigate();
    const location = useLocation();

    // Pobieranie danych użytkownika
    useEffect(() => {
        const fetchUserDetails = async () => {
            const token = localStorage.getItem('authToken');

            if (!token) {
                navigate('/login');
                return;
            }

            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/api/users/user`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
                setUserDetails(response.data);
            } catch (error) {
                console.error('Błąd podczas ładowania danych użytkownika', error);
                logout();
                navigate('/login');
            }
        };

        fetchUserDetails();
    }, [logout, navigate]);

    // Obsługa zakładki jeśli przyszła z menu
    useEffect(() => {
        if (location.state?.tab) {
            setActiveTab(location.state.tab);
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    if (!userDetails.email) return <p>Ładowanie danych użytkownika...</p>;

    // Jeśli to admin, przekieruj na /admin
    if (userDetails.role === 'admin') {
        return <Navigate to="/admin" replace />;
    }

    return (
        <div className="profile">
            <h1>Profil użytkownika</h1>
            {/* Zakładki */}
            <div className="tabs">
                <button className={`tab-button ${activeTab === 'userInfo' ? 'active' : ''}`} onClick={() => setActiveTab('userInfo')}>
                    Dane użytkownika
                </button>
                <button className={`tab-button ${activeTab === 'orders' ? 'active' : ''}`} onClick={() => setActiveTab('orders')}>
                    Zamówienia
                </button>
                <button className={`tab-button ${activeTab === 'cart' ? 'active' : ''}`} onClick={() => setActiveTab('cart')}>
                    Koszyk
                </button>
                <button className={`tab-button ${activeTab === 'favorites' ? 'active' : ''}`} onClick={() => setActiveTab('favorites')}>
                    Ulubione
                </button>
            </div>

            {/* Treść zakładek */}
            <div className="tab-content">
                {activeTab === 'userInfo' && <UserPersonalInfo userDetails={userDetails} />}
                {activeTab === 'orders' && <UserOrders orders={userDetails.orders || []} />}
                {activeTab === 'addresses' && <UserAddresses addresses={userDetails.addresses || []} />}
                {activeTab === 'cart' && <UserCart cart={userDetails.cart || []} />}
                {activeTab === 'favorites' && <UserFavorites favorites={userDetails.favorites || []} />}
            </div>
        </div>
    );
}

export default PageProfile;